import { Chip, useTheme } from "@mui/material"
import Icon from "../../Icon/Icon"
import { useIsHovering } from "../../../hooks/useIsHovering";

/**
 * Chips para mostrar incormacion corta y consisa
 * @param {string | HTMLElement} label texto a mostrarse de el chip 
 * @param {Icon | HTMLElement} icon nombre del icono a mostrarse en icon-map
 * @param {string} variant tipo de chip ('filled' | 'outlined')
 * @param {string} color color del chip ('default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning')
 * @returns {Chip}
 */
export const ChipInfo = ({ 
  label = '',
  icon = null,
  height = 24,
  variant='outlined',
  color = 'primary',
  showAllways = true,
  maxWidth = 200,
  sx,
}) => {

  const theme = useTheme();
  const [isHovering, handleMouseOver, handleMouseOut] = useIsHovering();

  const getIconColor = () =>  theme.palette.white.main;

  return (
    <Chip 
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
      label={<div style={{ overflow: 'visible' }}>{label}</div>} 
      icon={icon} 
      variant={variant}
      color={color}
      sx={{
        height,
        minWidth: height,
        fontSize: 12,
        color: theme.palette.oxfordBlue.main,
        '&.MuiChip-root': {
          borderLeft: 0,
          ...(!showAllways 
            && !isHovering 
            && {
              transition: 'border-color, background-color 0ms, ease-in-out',
              transitionDelay: '200ms',
              border: '0px solid transparent',
              backgroundColor: 'transparent',

            }
          )
        },
        '& .MuiChip-icon': {
          backgroundColor: theme.palette[color]?.main ||  theme.palette.blueGray200.main,
          marginLeft: 0,
          borderRadius: '50%',
          padding: .3,
          height,
          width: height,
          margin: 0,
          overflow: 'visible'
        },
        '& .MuiChip-label': {
          transition: 'all 200ms linear',
          maxWidth: 0,
          overflow: 'hidden',
          ...(showAllways 
            ? {
              maxWidth
            }
            : isHovering 
              ? {
                maxWidth
              } 
              : {
                maxWidth: 0,
                padding: 0,
              }
          )
        },
        '& svg g, & svg path': {
          fill: getIconColor()
        },
        ...sx
      }}
    />
  )
}